import { IndicatorType } from '../constants/common'
import Indicator from './indicator'

interface Attrs {
  period: string
}

class RSI extends Indicator<Attrs> {
  static type = IndicatorType.Rsi
  static label = 'Relative Strength Index'

  rsi: number[] = []
  declare period: number

  set(values: Partial<Attrs>) {
    super.set(values)
    this.parsePeriodInt(values)
  }

  compute() {
    if (!this.isComputeNecessary()) return

    this.rsi = []
    let count = 0
    let sumu = 0
    let sumd = 0
    let u: number, d: number, ad: number, au: number
    for (let i = 1; i < this.data.close.length; i++) {
      u = d = 0
      if (this.data.close[i] > this.data.close[i - 1]) {
        u = this.data.close[i] - this.data.close[i - 1]
      }
      if (this.data.close[i] < this.data.close[i - 1]) {
        d = this.data.close[i - 1] - this.data.close[i]
      }

      if (count < this.period) {
        sumu += u
        sumd += d
        count++
        au = sumu / count
        ad = sumd / count
      } else {
        au = (au! * (this.period - 1) + u) / this.period
        ad = (ad! * (this.period - 1) + d) / this.period
      }

      const rs = ad > 0 ? au / ad : 1
      this.rsi[i] = 100 - 100 * (1 / (1 + rs))
    }

    this.lastValue = this.rsi.last() ?? null
    const { min, max } = this.getDomainDefaults(this.type)
    this.min = min
    this.max = max
  }

  renderIndicator(context: CanvasRenderingContext2D) {
    this.renderOversoldOverbought(context, this.rsi, 1, 30, 50, 70)
  }

  getModalConfig() {
    const period = {
      type: 'number',
      label: 'Period',
      name: 'period',
      value: this.period ?? 14,
      required: true,
      min: 1,
      max: 999999,
    }

    return {
      title: this.label,
      inputs: [period],
      inputsErrorMessages: {
        period: `${period.label} must be a whole number between ${period.min} and ${period.max}`,
      },
    }
  }

  getIsValid(key: string): boolean {
    switch (key) {
      case 'period':
        return this.getIsNumberInputValid({ key })
      default:
        return false
    }
  }

  toString() {
    return `RSI ${this.period}`
  }
}

export default RSI
